module.exports = __webpack_public_path__ + "static/media/IMG_013.eb45716d.JPG";